/**
 * Created by andrey on 28.07.2023
 */

const Map2dChessGroundView = cc.Sprite.extend({ 
    ctor: function (frame) {
        this._super(frame);
        this.init(frame);
    },

    reuse: function (frame) {
        this.setSpriteFrame(frame);

        this.init(frame);

        this._super();
    },

    init: function (frame) {
        this.setLocalZOrder(cleverapps.config.debugMode && frame === bundles.dev_resources.frames.chess_debug ? 100 : 0);
    }
});

Map2dChessGroundView.PoolLimit = 500;

Map2dChessGroundView.IsEnabled = function () {
    if (!Map2d.currentMap) {
        return false;
    }

    const tilesTexture = Map2d.getTilesTexture(Map2d.currentMap.tilesSkin);
    return !bundles[tilesTexture].meta.disableChessGround;
};

Map2dChessGroundView.GetFromPool = function (frame) {
    if (!frame) {
        return;
    }

    if (cleverapps.config.debugMode) {
        const visible = frame === bundles.dev_resources.frames.chess_debug
            ? Map2d.impassableCellsVisible : Map2d.chessLayerVisible;
        if (!visible) {
            return;
        }
    } else if (!Map2dChessGroundView.IsEnabled()) {
        return;
    }

    return cleverapps.pool.getFromPool(Map2dChessGroundView, frame) || new Map2dChessGroundView(frame);
};